__turbopack_context__.v({
  "arrow": "SettingTab-module-scss-module__EHkXgG__arrow",
  "arrowHead": "SettingTab-module-scss-module__EHkXgG__arrowHead",
  "arrowIcon": "SettingTab-module-scss-module__EHkXgG__arrowIcon",
  "flag": "SettingTab-module-scss-module__EHkXgG__flag",
  "flagWrapper": "SettingTab-module-scss-module__EHkXgG__flagWrapper",
  "iconWrapper": "SettingTab-module-scss-module__EHkXgG__iconWrapper",
  "languageButton": "SettingTab-module-scss-module__EHkXgG__languageButton",
  "settingButton": "SettingTab-module-scss-module__EHkXgG__settingButton",
  "settingText": "SettingTab-module-scss-module__EHkXgG__settingText",
  "settingToggle": "SettingTab-module-scss-module__EHkXgG__settingToggle",
  "settingsButton": "SettingTab-module-scss-module__EHkXgG__settingsButton",
  "toggleSlider": "SettingTab-module-scss-module__EHkXgG__toggleSlider",
  "toggleSwitch": "SettingTab-module-scss-module__EHkXgG__toggleSwitch",
});
